export class Country {
    constructor(private _countryCode : string, private _countryName: string) {

    }

    get countryCode(): string {
        return this._countryCode;
    }

    get countryName(): string {
        return this._countryName;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestList/models/country.ts
 **/